import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const issueCategories = [
  "Błąd formatowania",
  "Obrazek nie pasuje do treści",
  "Obrazek się nie wczytał",
  "Błąd w treści zadania",
  "Nieprawidłowe rozwiązanie",
  "Pojęcia spoza zakresu maturalnego",
  "Zadania nie da się wykonać bez obliczeń na kartce",
  "Rozwiązanie jest zbyt szczegółowe",
  "Rozwiązanie jest zbyt mało szczegółowe",
  "Punkty źle przypisane do zadania",
];

const formConfig = {
  'page-issue': { title: "Zgłoś problem ze stroną" },
  'task-issue': { title: "Zgłoś problem z zadaniem" },
  'suggestion': { title: "Zaproponuj ulepszenie" }
};

const ContactModal = ({ onClose, type, issueData }) => {
  const [formData, setFormData] = useState({
      page_url: window.location.href,
      description: '',
  });
  const [selectedIssueCategory, setSelectedIssueCategory] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const modalRef = useRef(null);
  const dropdownRef = useRef(null);
  
  const currentConfig = formConfig[type] || {};
  const apiUrl = process.env.REACT_APP_API_SOURCE;
  const token = localStorage.getItem("token");

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectCategory = (cat) => {
    setSelectedIssueCategory(cat);
    setIsDropdownOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let report_category = '';
    let report_details = formData.description;
    
    let payload = {
      problem_id: issueData?.problem_id || null,
      field_id: issueData?.field_id || null,
      report_category: '',
      report_details: ''
    };

    if (type === 'task-issue') {
      report_category = selectedIssueCategory;
    } else if (type === 'suggestion') {
      report_category = 'Ulepszenie';
    } else if (type === 'page-issue') {
      report_category = 'Problem ze strona';
      
      // --- POCZĄTEK ZMIANY: Dodajemy dane diagnostyczne ---
      
      // 1. Zbierz dodatkowe informacje
      const userAgent = navigator.userAgent;
      const screenResolution = `${window.screen.width}x${window.screen.height}`;
      const viewportSize = `${window.innerWidth}x${window.innerHeight}`;

      // 2. Sformatuj dane w czytelny sposób
      const diagnosticData = `
---
Dane diagnostyczne:
URL: ${formData.page_url}
Przeglądarka: ${userAgent}
Rozdzielczość ekranu: ${screenResolution}
Rozmiar okna przeglądarki: ${viewportSize}`;

      // 3. Połącz opis użytkownika z danymi diagnostycznymi
      report_details = `${formData.description}\n\n${diagnosticData}`;
      
      // --- KONIEC ZMIANY ---
    }

    if (!report_category || !formData.description.trim()) { // Sprawdzamy oryginalny opis
      alert("Proszę wypełnić wszystkie wymagane pola.");
      setLoading(false);
      return;
    }

    payload.report_category = report_category;
    payload.report_details = report_details;
    
    try {
      const response = await fetch(`${apiUrl}report_issues/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Token ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert("Zgłoszenie wysłane pomyślnie! Dziękujemy.");
        onClose();
      } else {
        const data = await response.json();
        alert("Wystąpił błąd: " + JSON.stringify(data));
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania zgłoszenia:", error);
      alert("Wystąpił błąd sieciowy. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
        <div ref={modalRef} className="relative z-[9991] bg-white p-6 rounded-lg shadow-2xl w-full max-w-md mx-4">
            <h2 className="text-lg font-bold mb-4">{currentConfig.title}</h2>
            <form onSubmit={handleSubmit}>

                {type === 'page-issue' && (
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-1">Adres URL strony</label>
                    <input type="text" name="page_url" value={formData.page_url} className="w-full border border-gray-300 rounded p-2 bg-gray-100" readOnly />
                </div>
                )}

                {type === 'task-issue' && (
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-1">Kategoria problemu</label>
                    <div className="relative" ref={dropdownRef}>
                    <button type="button" className="w-full border border-gray-300 rounded p-2 text-left flex justify-between items-center" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                        <span>{selectedIssueCategory ? selectedIssueCategory : "Wybierz kategorię"}</span>
                        <svg className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute w-full max-h-48 overflow-y-auto bg-white border border-gray-200 mt-1 rounded shadow-lg z-10">
                        {issueCategories.map((cat, index) => (
                            <div key={index} onClick={() => handleSelectCategory(cat)} className="p-2 hover:bg-gray-100 cursor-pointer text-sm leading-tight break-words">
                            {cat}
                            </div>
                        ))}
                        </div>
                    )}
                    </div>
                </div>
                )}

                <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Szczegóły</label>
                <textarea
                    name="description"
                    onChange={handleInputChange}
                    className="w-full border border-gray-300 rounded p-2 focus:ring-2 focus:ring-[#233855] outline-none"
                    rows="4"
                    placeholder="Opisz jak najdokładniej swój problem lub pomysł..."
                    required
                />
                </div>

                <div className="flex justify-end space-x-2 mt-2">
                <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300" disabled={loading}>
                    Anuluj
                </button>
                <button type="submit" className="px-4 py-2 rounded bg-[#233855] text-white hover:bg-blue-700 disabled:bg-blue-200" disabled={loading || (type === 'task-issue' && !selectedIssueCategory)}>
                    {loading ? "Wysyłanie..." : "Wyślij zgłoszenie"}
                </button>
                </div>
            </form>
        </div>
    </div>,
    document.body
  );
};

export default ContactModal;